import { Card, CardBody } from '@chakra-ui/react';
import { getCoreRowModel, useReactTable } from '@tanstack/react-table';
import { useMemo } from 'react';

import { ResourceType } from '../_openapi/portfolio-optimizer';
import { useRestrictions } from '../api/restrictions';
import { PageHeader } from '../widgets/PageHeader';
import { AsOfDateTag } from '../widgets/Table/AsOfDateTag';
import { Pagination } from '../widgets/Table/Pagination';
import { Table } from '../widgets/Table/Table';
import { TableControls } from '../widgets/Table/TableControls';
import { usePersistentTableState } from '../widgets/Table/usePersistentTableState';
import { useTableColumnSettings } from '../widgets/Table/useTableColumnSettings';
import { restrictionListColumns } from './restrictionListColumns';
import { useRestrictionRowActions } from './useRestrictionRowActions';

export const RestrictionsList = () => {
    const { restrictionActionColumn, drawers } = useRestrictionRowActions();

    const { pagination, setPagination, sorting, setSorting, resetTable, columnFilters, setColumnFilters } =
        usePersistentTableState(restrictionListColumns);

    const { data: restrictionPage, isFetching } = useRestrictions({ pagination, columnFilters, sorting });

    const { columnVisibility, setColumnVisibility, columnOrder, setColumnOrder } =
        useTableColumnSettings('restrictions');

    const columns = useMemo(() => [restrictionActionColumn, ...restrictionListColumns], [restrictionActionColumn]);

    const table = useReactTable({
        data: restrictionPage?.restrictions || [],
        columns: columns,
        state: {
            columnVisibility,
            columnOrder,
            pagination,
            sorting,
            columnFilters,
        },
        initialState: {
            columnPinning: {
                left: ['contextMenu'],
            },
        },
        onColumnFiltersChange: setColumnFilters,
        onColumnVisibilityChange: setColumnVisibility,
        onColumnOrderChange: setColumnOrder,
        onPaginationChange: setPagination,
        onSortingChange: setSorting,
        manualPagination: true,
        manualSorting: true,
        manualFiltering: true,
        sortDescFirst: false,
        getCoreRowModel: getCoreRowModel(),
    });

    return (
        <>
            <PageHeader title="Restrictions">
                <AsOfDateTag dateString={restrictionPage?.asOfDate} />
            </PageHeader>
            <Card>
                <CardBody>
                    <TableControls table={table} onReset={resetTable} resourceType={ResourceType.RESTRICTION} />
                    <Table table={table} isLoading={isFetching} allowXOverflow />
                    <Pagination table={table} totalItems={restrictionPage?.totalNr} />
                </CardBody>
            </Card>
            {drawers}
        </>
    );
};
